import { render, staticRenderFns } from "./ServerMessages.vue?vue&type=template&id=63642dd5&"
import script from "./ServerMessages.vue?vue&type=script&lang=js&"
export * from "./ServerMessages.vue?vue&type=script&lang=js&"
import style0 from "./ServerMessages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
